import { useEffect,useState } from 'react';
import { KTIcon } from '../../../../_metronic/helpers';
import axios from 'axios';
import { EntitlementForti } from './components/ModalEntitlementsForti';
import { useNavigate } from 'react-router-dom';
import { getentitlements,getentitlementstenant } from './request/request';
import { useAppSelector } from '../../../../redux/hooks';
import Swal from 'sweetalert2';
import { useAuth } from '../../auth';

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

function FortinetEntitlementCrud() {
    const{currentUser}= useAuth()
    const tenant= useAppSelector(state =>state.TenantSlice.id)



    /* variable para el modal  */
    const [ ID , setID]=useState<ID>(undefined)
    /*__________________________*/

    const navigate= useNavigate()
    const [records,setRecords]= useState<any|null>([ ])

    


    /**********************Llamada a axios y parse de data**********************/

    useEffect( () => {
      if (currentUser?.ListPermiso?.includes('Ctx.NGFW.Entitlement.List')){
         if(tenant ===0){
            getentitlements('Ctx.NGFW.Entitlement.List').then(response=>{
                if (response.data.length >0){
                    setRecords(response.data)
                }
                else{
                    setRecords([])
                }
            })
         }
         else if(tenant !==0){
            getentitlementstenant(tenant,'Ctx.NGFW.Entitlement.List').then(response=>{
                if (response.data.length >0){
                    setRecords(response.data)
                }
                else{
                    setRecords([])
                }
            })
         }
        }
        }, [tenant])

     

    /***********************************************************************************/
  
    



    return(
        <>
        <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>Entitlement Management</span>
            </h3>
            {/*Se agrega Boton para agregar usuarios*/}
            {/*currentUser?.ListPermiso?.includes('Roles.Create') && <button onClick={ () => setID(null)} className='btn-light-marino f-parrafo'>CREATE</button>*/}
        </div>

        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
            <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                {/* begin::Table container */}
                <div className='table-responsive'>

                {/* begin::Table */}
                    <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                        {/* begin::Table head */}
                        <thead>
                
                            <tr className="table-header-light bg-marino">
                                <th className='table-cell' style={{width:'300px'}}>Name</th>
                                <th className='table-cell'>VDOM</th>
                                <th className='table-cell'>VCPUs</th>
                                <th className='table-cell'>Fortguard Bundle</th>




                            </tr>
                        </thead>
                        {/* end::Table head */}


                        {/* begin::Table body */}
                        <tbody>
                            {records.map((d:any,i:any)=>(
                                    <tr key={i} className='table-row'> 
                           
                                        <td className='table-cell'>{d.name}</td>
                                        <td className='table-cell'>{d.VDOM}</td>
                                        <td className='table-cell'>{d.vcpu}</td>
                                        <td className='table-cell'>{d.nivel}</td>

                                        
                                    </tr>
                                ))
                            }

                        </tbody>
                          {/* end::Table body */}

                    </table>
                     {/* end::Table */}
                </div>
               

            </div>
            {/* end::Tap pane */}
            </div>
        </div>
        <br />
        {/* end::Body */}
        </div>
        
        {ID !== undefined && <EntitlementForti setID={setID} id={ID} />}

        
        </>

	);
    {/*function handleSubmit(id:any){
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Role!",
            showCancelButton:true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          })
          .then((result) => {
            if (result.isConfirmed) {
                if(tenant===0){
                    axios.delete(API_URL+'/v1/rol/'+id)
                    .then(res=>{
                    if  (res.data.status==='successful'){
                    Swal.fire(
                        'Deleted!',
                        'Your Role has been deleted.',
                        'success'
                    );}
                    else{
                        Swal.fire(
                            'error!',
                            'your role could not be eliminated!',
                            'error'
                        );
                    }
                    getRolesList().then(response=>{
                        setRecords(response.data)
                    })
                })
                   

                }
                else{
                    axios.delete(API_URL+'/v1/rol/'+id+'?tenantId='+tenant)
                    .then(res=>{
                        if  (res.data.status==='successful'){
                            Swal.fire(
                                'Deleted!',
                                'Your Role has been deleted.',
                                'success'
                            );}
                            else{
                                Swal.fire(
                                    'error!',
                                    'your role could not be eliminated!',
                                    'error'
                                );
                            }
                    getRolesListglobal(tenant).then(response=>{
                        setRecords(response.data)
                    })
                })
                
                }
             
            } else {
              Swal.fire({title:"Your Role is safe!", icon: "success"});
            }
          });
        
        
    }*/}
    }

export default FortinetEntitlementCrud